import { connect } from "react-redux";

import {
  addPublishNotification,
  clientWebHookPublish,
  fetchMe,
  fetchUserDetails,
  getOrganizationStorage,
  getSocialProfiles,
  getUsersByUserIds,
} from "../../store/user/duck";
import {
  addSocialMediaData,
  addThumbnail,
  advanceEditorIllusto,
  bucketCopy,
  bulkS3BucketPublish,
  clipExportEDL,
  clipExportJson,
  clipExportXml,
  clipListFolder,
  copyClip,
  copyClipToReviewer,
  createFolder,
  createHighlight,
  createPreview,
  createSocialMediaCaption,
  deleteClips,
  deleteEditedClip,
  deleteFolder,
  deleteHlsToMp4,
  downloadAllClips,
  downloadClips,
  downloadClipZipPackage,
  downloadVideo,
  dumpOnS3,
  editClip,
  fetchBrightCoveToken,
  fetchStorage,
  ftpPublish,
  generateAutoFlip,
  GenerateVideoTitle,
  genrateNewClip,
  getAllClips,
  getAspectRatios,
  getCategoryConfiguration,
  getClipsByFolder,
  getClipsCount,
  getClipSizeByUrl,
  getCloudPreSignedURL,
  getCsvData,
  getCustomFields,
  getDownloadBulkVideo,
  getDownloadStatus,
  getDownloadVideo,
  getDownloadVideoStatus,
  getEventStream,
  getFolders,
  getftplist,
  getHLSToMP4,
  getIllustoClipStatus,
  getPlayerStream,
  getPresignedUrl,
  getPublicUrls,
  getSingleFolder,
  getSportsDetail,
  getStreamDetails,
  getTrimClip,
  getUploadPicture,
  getVideoMetaData,
  isValidStream,
  jsonBucketPublish,
  overWriteClip,
  publishClip,
  publishZeeThumbnails,
  regenerateThumbnail,
  registerAryshareWebhook,
  s3BucketPublish,
  shareOnSocialMedia,
  shareOnSocialMedias,
  singleClipDetail,
  twitterShare,
  updateClipDetail,
  updateFolder,
  updateHighlightFolder,
  updatesftp,
  updateVideoData,
  uploadClip,
  uploadClipInBrightCove,
  uploadToThirdPartyS3Publish,
  validateStreamAccess,
  youtubeShare,
} from "../../store/videogrid/duck";
import ClipsComponent from "./component";

const ClipsContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {
    getSportsDetail,
    getStreamDetails,
    getAllClips,
    getPlayerStream,
    getEventStream,
    getClipsCount,
    createFolder,
    updateFolder,
    deleteClips,
    getFolders,
    deleteFolder,
    fetchStorage,
    createHighlight,
    createPreview,
    shareOnSocialMedia,
    twitterShare,
    youtubeShare,
    getPublicUrls,
    getClipsByFolder,
    shareOnSocialMedias,
    fetchMe,
    ftpPublish,
    copyClip,
    editClip,
    publishClip,
    getTrimClip,
    s3BucketPublish,
    bulkS3BucketPublish,
    jsonBucketPublish,
    downloadVideo,
    updateHighlightFolder,
    getAspectRatios,
    generateAutoFlip,
    singleClipDetail,
    clipExportJson,
    clipExportEDL,
    downloadClips,
    clientWebHookPublish,
    dumpOnS3,
    updatesftp,
    getftplist,
    bucketCopy,
    fetchUserDetails,
    copyClipToReviewer,
    uploadClipInBrightCove,
    fetchBrightCoveToken,
    getCustomFields,
    getUsersByUserIds,
    addThumbnail,
    getUploadPicture,
    updateClipDetail,
    GenerateVideoTitle,
    clipListFolder,
    genrateNewClip,
    uploadClip,
    downloadAllClips,
    isValidStream,
    deleteEditedClip,
    overWriteClip,
    getCategoryConfiguration,
    getClipSizeByUrl,
    addSocialMediaData,
    clipExportXml,
    getSingleFolder,
    getVideoMetaData,
    getPresignedUrl,
    addPublishNotification,
    getHLSToMP4,
    deleteHlsToMp4,
    updateVideoData,
    advanceEditorIllusto,
    getCsvData,
    uploadToThirdPartyS3Publish,
    getIllustoClipStatus,
    createSocialMediaCaption,
    getOrganizationStorage,
    validateStreamAccess,
    downloadClipZipPackage,
    publishZeeThumbnails,
    registerAryshareWebhook,
    regenerateThumbnail,
    getSocialProfiles,
    getCloudPreSignedURL,
    getDownloadVideo,
    getDownloadVideoStatus,
    getDownloadBulkVideo,
    getDownloadStatus,
  },
)(ClipsComponent);

export default ClipsContainer;
